import { useState, useEffect, useRef } from 'react';
import XTable from 'components/XTable';
import {
    Space,
    Input,
    Select,
    Modal,
    Button,
    notification,
    Divider,
    DatePicker,
    Tag,
    Popconfirm,
} from 'antd';
import { getFilterText, downFile } from 'utils';
import { applyStatus } from 'enumeration/applyStatus';
import { nursingAreas } from 'enumeration/nursingAreas';
import { sexTypes } from 'enumeration/sexTypes';
import { useHistory, useLocation } from 'react-router-dom';
import ApplyInfo from 'pages/applyInfo';

import {
    userApplyListApi,
    userSelfApplyListApi,
    userApplyReviewListApi,
    waitApproveListApi,
    preHospitalListApi,
    checkInListApi,
    putApplyReviewApi,
    putApplyApprovalApi,
    putApplyEvaluateApi,
    putApplyAdmissionApi,
    putApplyCancelApi,
    getApproveRecordApi,
    getDownloadApi,
    getApproveUserApi,
    recoverApi,
    pauseApi,
} from 'api/waitApplication';
import moment from 'moment';
import './style.less';
const { RangePicker } = DatePicker;
const { Option } = Select;
const pageConfigs = {
    applySelfProgress: {
        tableApi: userSelfApplyListApi,
        detailUrl: '/applySelfProgress/applyDetail',
        cancelApi: putApplyCancelApi,
        applyEdit: true,
        showDownlaod: true,
    }, // 用户查询申请进度
    applyProgress: {
        tableApi: userApplyListApi,
        detailUrl: '/applyProgress/applyDetail',
        cancelApi: putApplyCancelApi,
    }, // 管理员查询申请进度
    applyReview: {
        tableApi: userApplyReviewListApi,
        approvalApi: putApplyReviewApi,
        cancelApi: putApplyCancelApi,
        node: 'WAIT_FOR_APPROVE ',
        nodeName: 'REVIEW',
    }, // 复核审批
    applyApproval: {
        tableApi: waitApproveListApi,
        approvalApi: putApplyApprovalApi,
        cancelApi: putApplyCancelApi,
        node: 'PRE_HOSPITAL_ASSESSMENT',
        nodeName: 'WAIT_FOR_APPROVE',
    }, // 轮候审批
    applyEvaluate: {
        tableApi: preHospitalListApi,
        approvalApi: putApplyEvaluateApi,
        node: 'CHECK_IN',
        cancelApi: putApplyCancelApi,
        nodeName: 'PRE_HOSPITAL_ASSESSMENT',
    }, // 院前评估审批
    applyAdmission: {
        tableApi: checkInListApi,
        approvalApi: putApplyAdmissionApi,
        cancelApi: putApplyCancelApi,
        nodeName: 'CHECK_IN',
    }, // 入院审批
};
const ApplyList = () => {
    const xTableRef = useRef();
    const history = useHistory();
    const { pathname } = useLocation();
    const [approveVisible, setApproveVisible] = useState(false);
    const [approveRecorVisible, setapproveRecorVisible] = useState(false);
    const [cancelVisible, setcancelVisible] = useState(false);
    const [applyId, setApplyId] = useState('');
    const [opinion, setOpinion] = useState('');
    const [actionLoading, setActionLoading] = useState(false);
    const [pageConfig, setPageConfig] = useState(pageConfigs[pathname.replace('/', '')] || {});
    const [confirm, setConfirm] = useState(false);
    const [size] = useState('default');
    const [children, setChildren] = useState([]);
    const [defaulchildren, setDefaultChildren] = useState([]);
    const [approveUser, setApproveUser] = useState([]);
    const [pauseVisible, setPauseVisible] = useState(false);

    function handleChange(value) {
        setApproveUser(value);
    }

    // 清空备注
    useEffect(() => {
        setOpinion('');
    }, [approveVisible, cancelVisible]);

    useEffect(() => {
        setPageConfig(pageConfigs[pathname.replace('/', '')] || {});
    }, [pathname]);

    // 跳转详情
    const seeDetail = id => {
        const detailUrl = pageConfig.detailUrl;
        history.push(`${detailUrl}/${id}`);
    };

    // 审批弹窗
    const approveDetail = id => {
        setApplyId(id);
        setApproveVisible(true);
    };

    // 审批操作记录弹窗
    const approveRecorShow = id => {
        setApplyId(id);
        setapproveRecorVisible(true);
    };

    // 撤销申请
    const applyCancel = id => {
        setApplyId(id);
        setcancelVisible(true);
    };

    // 执行撤销
    const doCancelApply = () => {
        if (!opinion) {
            notification.error({
                message: '请输入撤销说明。',
            });
            return;
        }
        const params = { opinion, id: applyId };
        setActionLoading(true);
        pageConfig.cancelApi(params).then(res => {
            if (res.success) {
                notification.success({
                    message: '撤销申请成功。',
                });
                handleCancel();
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            setActionLoading(false);
        });
    };

    // 申请变更
    const applyEdit = id => {
        history.push(`/applySelfProgress/applyEdit/${id}`);
    };

    // 审批
    const handleApprove = waitApplicationEvent => {
        if (!opinion) {
            notification.error({
                message: '请输入审批意见。',
            });
            return;
        }

        setActionLoading(true);
        const params = { waitApplicationEvent, opinion, id: applyId, approveUser: approveUser };
        pageConfig.approvalApi(params).then(res => {
            if (res.success) {
                notification.success({
                    message: '审批成功。',
                });
                setApproveVisible(false);
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            setActionLoading(false);
            setConfirm(false);
        });
    };

    const recover = id => {
        setActionLoading(true);
        const params = { id };
        recoverApi(params).then(res => {
            if (res.success) {
                notification.success({
                    message: '操作成功。',
                });
                setApproveVisible(false);
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            setActionLoading(false);
        });
    };

    const doPause = () => {
        const params = { id: applyId, opinion: opinion, nodeName: pageConfig.nodeName };
        console.log(params);
        pauseApi(params).then(res => {
            if (res.success) {
                notification.success({
                    message: '操作成功。',
                });
                handleCancel();
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            setActionLoading(false);
        });
    };

    // 关闭弹窗
    const handleCancel = () => {
        setApproveVisible(false);
        setapproveRecorVisible(false);
        setcancelVisible(false);
        setPauseVisible(false);
        setApplyId('');
        setOpinion('');
    };

    const columns = [
        {
            title: '轮候号',
            dataIndex: 'waitNo',
        },
        {
            title: '审批状态',
            dataIndex: 'status',
            render: val => getFilterText(applyStatus, val),
        },
        {
            title: '护理区',
            dataIndex: 'nursingArea',
            render: val => getFilterText(nursingAreas, val),
        },
        {
            title: '申请人',
            dataIndex: 'name',
        },
        {
            title: '性别',
            dataIndex: 'sex',
            render: val => getFilterText(sexTypes, val),
        },
        {
            title: '申请日期',
            dataIndex: 'createAt',
            render: val => (val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
        {
            title: '监护人',
            dataIndex: 'guardian',
        },
        {
            title: '监护人电话',
            dataIndex: 'guardianCellPhone',
        },
        {
            title: '提交号',
            dataIndex: 'applicationNo',
        },
        {
            title: '操作',
            dataIndex: 'action',
            render: (text, record) => (
                <Space size="middle">
                    {pageConfig.detailUrl ? (
                        <span className="actionText" onClick={() => seeDetail(record.id)}>
                            查看详情
                        </span>
                    ) : null}
                    {pageConfig.applyEdit && record.status === 'WAIT_REVIEW' ? (
                        <span className="actionText" onClick={() => applyEdit(record.id)}>
                            申请变更
                        </span>
                    ) : null}
                    {pageConfig.cancelApi && record.status === 'WAIT_REVIEW' ? (
                        <span className="actionText" onClick={() => applyCancel(record.id)}>
                            撤销
                        </span>
                    ) : null}
                    {record.isPause === 1 ? (
                        <Popconfirm
                            title="确定恢复流程？"
                            okText="确定"
                            cancelText="取消"
                            onConfirm={() => recover(record.id)}>
                            <span className="actionText">恢复流程</span>
                        </Popconfirm>
                    ) : null}
                    {pageConfig.approvalApi ? (
                        <span className="actionText" onClick={() => approveDetail(record.id)}>
                            审批
                        </span>
                    ) : null}
                    {pageConfig.approvalApi ? (
                        <span className="actionText" onClick={() => applyPause(record.id)}>
                            挂起
                        </span>
                    ) : null}
                    <span className="actionText" onClick={() => approveRecorShow(record.id)}>
                        审批操作记录
                    </span>
                </Space>
            ),
        },
    ];
    const queryItems = [
        {
            formItemApis: {
                label: '审批状态',
                help: null,
                name: 'status',
            },
            item: (
                <Select style={{ width: 150 }} placeholder="请选择" allowClear>
                    {applyStatus.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value} selected="true">
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
        {
            formItemApis: {
                label: '护理区',
                help: null,
                name: 'nursing_ares',
            },
            item: (
                <Select style={{ width: 150 }} placeholder="请选择" allowClear>
                    {nursingAreas.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
        {
            formItemApis: {
                label: '申请人',
                help: null,
                name: 'name',
            },
            item: <Input style={{ width: 150 }} allowClear />,
        },
        {
            formItemApis: {
                label: '申请日期',
                help: null,
                name: 'createDate',
            },
            item: <RangePicker format="YYYY-MM-DD" />,
        },
        {
            formItemApis: {
                label: '轮候号',
                help: null,
                name: 'waitNo',
            },
            item: <Input style={{ width: 150 }} allowClear />,
        },
    ];

    const handelParams = params => {
        const { createDate, ...otherParams } = params;
        let beginDate = '';
        let endDate = '';
        let newParams = otherParams;
        if (createDate && createDate.length) {
            beginDate = moment(createDate[0]).format('YYYY-MM-DD');
            endDate = moment(createDate[1]).format('YYYY-MM-DD');
            newParams = { ...otherParams, beginDate, endDate };
        }
        return newParams;
    };

    // 添加备注输入
    const opinionItemRender = type => {
        const label = type === 'cancel' ? '撤销说明' : '审批意见';
        return (
            <div style={{ display: 'flex' }} className="remarkBox">
                <div className="labelLine">
                    <span className="requiredStar">{label}：</span>
                </div>
                <div style={{ flex: 1 }}>
                    <Input
                        placeholder={`请输入${label}`}
                        style={{ width: '100%' }}
                        value={opinion}
                        onChange={e => {
                            setOpinion(e.target.value);
                        }}
                    />
                </div>
            </div>
        );
    };

    const opinionPause = () => {
        return (
            <div style={{ display: 'flex' }} className="remarkBox">
                <div className="labelLine">
                    <span className="requiredStar">挂起原因：</span>
                </div>
                <div style={{ flex: 1 }}>
                    <Input
                        placeholder={`请输入挂起原因：`}
                        style={{ width: '100%' }}
                        value={opinion}
                        onChange={e => {
                            setOpinion(e.target.value);
                        }}
                    />
                </div>
            </div>
        );
    };

    const downloadRecord = () => {
        const queryValue = xTableRef.current.queryForm?.getFieldsValue();
        const params = handelParams(queryValue);
        getDownloadApi(params).then(res => {
            if (res.success) {
                const filename = `申请记录${moment().valueOf()}.xls`;
                downFile(res.file, filename);
            }
        });
    };

    const handleCancelConfirm = () => {
        setConfirm(false);
    };
    const hanConfirm = () => {
        if (!opinion) {
            notification.error({
                message: '请输入审批意见。',
            });
            return;
        }
        setChildren([]);
        setDefaultChildren([]);
        setConfirm(true);
        if (pageConfig.node !== undefined) {
            const params = { node: pageConfig.node };
            const queryValue = [];
            const defaultContent = [];
            getApproveUserApi(params).then(res => {
                if (res.success) {
                    res.data.map(item => {
                        queryValue.push(<Option key={item.id}>{item.username}</Option>);
                        defaultContent.push(item.username);
                        return queryValue;
                    });
                    setChildren(queryValue);
                    setDefaultChildren(defaultContent);
                }
            });
        }
    };

    const applyPause = id => {
        setApplyId(id);
        setPauseVisible(true);
    };
    const actionBtns = [{ text: '导出申请审批', onClick: downloadRecord }];

    return (
        <div className="applyList">
            <XTable
                columns={columns}
                handelParams={handelParams}
                queryItems={queryItems}
                actionBtns={actionBtns}
                api={pageConfig.tableApi}
                rowKey="id"
                ref={xTableRef}
            />
            {applyId && approveVisible ? (
                <Modal
                    title="审批"
                    width={1400}
                    centered
                    visible={approveVisible}
                    wrapClassName="infolistModal"
                    footer={[
                        <Button type="primary" onClick={hanConfirm}>
                            同意
                        </Button>,
                        <Button onClick={() => handleApprove('REFUSE')} loading={actionLoading}>
                            不同意
                        </Button>,
                        <Button onClick={handleCancel}>关闭</Button>,
                    ]}
                    onCancel={handleCancel}>
                    <div className="infoList">
                        <ApplyInfo applyId={applyId} />
                        <Divider>审批信息</Divider>
                        {opinionItemRender()}
                    </div>
                    <Modal
                        title={
                            pageConfig.node !== undefined ? '确定同意?' : '是否确定该申请人入院?'
                        }
                        centered
                        visible={confirm}
                        onOk={() => handleApprove('AGREE')}
                        wrapClassName="infoConfirmModal"
                        onCancel={handleCancelConfirm}>
                        {pageConfig.node !== undefined ? (
                            <p>
                                <Tag color="#f50">同意后流程将进入下个环节</Tag>
                            </p>
                        ) : (
                            <p>
                                <Tag color="#f50">该申请人将入院</Tag>
                            </p>
                        )}
                        {pageConfig.node !== undefined ? (
                            <Select
                                mode="multiple"
                                size={size}
                                placeholder="请选择短信通知人员"
                                defaultOpen={true}
                                autoFocus={true}
                                defaultValue={defaulchildren}
                                onChange={handleChange}
                                style={{ width: '100%' }}>
                                {children}
                            </Select>
                        ) : (
                            ''
                        )}
                    </Modal>
                </Modal>
            ) : null}
            {applyId && cancelVisible ? (
                <Modal
                    title="撤销申请"
                    width={666}
                    centered
                    visible={cancelVisible}
                    wrapClassName="confirmModal"
                    onOk={doCancelApply}
                    okButtonProps={{ loading: actionLoading }}
                    onCancel={handleCancel}>
                    <div className="infoList">{opinionItemRender('cancel')}</div>
                </Modal>
            ) : null}
            {applyId && approveRecorVisible ? (
                <Modal
                    title="审批操作记录"
                    width={1200}
                    centered
                    visible={approveRecorVisible}
                    footer={[
                        <Button type="primary" onClick={handleCancel}>
                            关闭
                        </Button>,
                    ]}
                    onCancel={handleCancel}>
                    <XTable
                        columns={[
                            {
                                title: '操作时间',
                                dataIndex: 'createAt',
                                render: val =>
                                    val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '-',
                            },
                            { title: '操作人', dataIndex: 'userName' },
                            { title: '流程节点', dataIndex: 'nodeName' },
                            { title: '处理结果', dataIndex: 'eventName' },
                            { title: '备注', dataIndex: 'description' },
                        ]}
                        size="small"
                        api={getApproveRecordApi}
                        apiParams={{ id: applyId }}
                        scrollY={'calc(100vh - 300px)'}
                        rowKey="id"
                    />
                </Modal>
            ) : null}
            {applyId && pauseVisible ? (
                <Modal
                    title="挂起"
                    width={666}
                    centered
                    visible={pauseVisible}
                    wrapClassName="confirmModal"
                    onOk={doPause}
                    okButtonProps={{ loading: actionLoading }}
                    onCancel={handleCancel}>
                    <div className="infoList">{opinionPause()}</div>
                </Modal>
            ) : null}
        </div>
    );
};

export default ApplyList;
